import { render } from "./PopularProducts.vue?vue&type=template&id=05281220&ts=true"
import script from "./PopularProducts.vue?vue&type=script&lang=ts"
export * from "./PopularProducts.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__